import styled from 'styled-components';
import { FieldArray } from 'formik';
import AddButton from "./UI/AddButton";
import Accordion from './UI/Accordion';
import FieldWithErrorDisplay from "./FieldWithErrorDisplay";
import FieldGroupContainer from "./UI/FieldGroupContainer";

const newMember = {
  title: "",
  name: "",
  phone: "",
  email: ""
}

const InputContainer = styled.div`
  width: calc(100% - 20px);
  margin-left: 20px;
`;

const MembersInput = ({members, setField, departmentIndex}) => {
  return (
    <FieldArray name={`departments[${departmentIndex}].members`}>
      {({ insert, remove, push }) => (
        <InputContainer>
        {members.length > 0 &&
          members.map((members, idx) => (
            <Accordion
              key={idx}
              title={members.title}
              fieldSetter={(e) => setField(`departments[${departmentIndex}].members[${idx}].title`, e.target.value)}
              subtitle={members.name}
              fieldSetter2={(event) => setField(`departments[${departmentIndex}].members[${idx}].name`, event.target.value)}
              deleteMethod={() => remove(idx)}
            >
              <FieldGroupContainer key={idx}>
                <FieldWithErrorDisplay
                  labelFor={`departments.${departmentIndex}.members.${idx}.phone`}
                  label="Phone Number"
                  type="tel"
                />
                <FieldWithErrorDisplay
                  labelFor={`departments.${departmentIndex}.members.${idx}.email`}
                  label="Email"
                  type="email"
                />
              </FieldGroupContainer>
            </Accordion>
          ))
        }
          <AddButton
            type="button"
            onClick={() => push({...newMember, title: `Department Role ${members.length + 1}`, name: "Department Member Name"})}
          >
            New Member
          </AddButton>
        </InputContainer>
      )}
    </FieldArray>
  )
}

export default MembersInput;
